// Built4Pressure homepage refresh — scroll-triggered "lift" on the spray headers.
(function () {
  var targets = document.querySelectorAll(
    '[id*="featured_variants_legacy"] h2.title, [id*="featured_product_f3gGg6"] .product__title, [id*="featured-collection-0"] h2.title'
  );
  if (!targets.length || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-lifted', entry.isIntersecting);
      });
    },
    { threshold: 0.5 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
